export default {
	"errorPage.title.oops": "Hoppla!",
	"errorPage.description.notFound": "Diese Seite wurde nicht gefunden.",
	"errorPage.description.findHere":
		"Vielleicht finden Sie hier das, was Sie suchen:",
	"errorPage.link.homepage": "Zur Startseite {site}",
} as const;
